import * as React from "react";
import {useState, useContext, useEffect} from "react";
import { useNavigate, useLocation } from "react-router";
import { useSearchParams, useParams } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext.component";
import logo from "../../../assets/logo.svg";
import "./style.scss";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Flex, Spinner, Text } from "@chakra-ui/react";


export function SignInFormCustomer() {
    const [jobNum, setJobNum] = useState<string>("");
    const [postcode, setPostcode] = useState<string>("");
    const [isError, setIsError] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    let { jobNumber } = useParams();

    const authContext = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    let navigate = useNavigate();
    let location = useLocation();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        setIsError(false);
        setIsLoading(true);
        e.preventDefault();

        console.log(`handleSubmit: ${jobNum.trim()} ${postcode.trim()}`)
        let response = await authContext.signInCustomer(jobNum.trim(), postcode.trim().replace(/\s+/g, ""));
        
        if (response) {
            console.log("Result")
            let returnUrl = searchParams.get("returnUrl");
        
            if (returnUrl != null) {
                console.log(decodeURIComponent(returnUrl));
                navigate(decodeURIComponent(returnUrl));
            }
            else {
                navigate("/customer/overview/" + jobNum);
            }
        } else {
            console.log("Error");
            setIsLoading(false);
            setIsError(true);
        }
    }

    useEffect(() => {
        if (jobNumber) {
            setJobNum(jobNumber);
            console.log(jobNumber);
        }
    }, []);

    return (
        <div className="sign-in-form">
            <div className="sign-in-form--left-panel">
                <div className="sign-in-form--text">
                    <div className="sign-in-form--text-top">
                        <img className="logo" src={logo} alt="Able Group"/>
                    </div>
                    <div className="sign-in-form--text-bottom">
                        <h3 className="sign-in-form--subheading">Welcome!</h3>
                        <p className="sign-in-form--paragraph">
                            Please login to view your ongoing job and view any documents.
                        </p>
                    </div>
                </div>
            </div>

            <form className={'sign-in-form--right-panel'} onSubmit={handleSubmit}>
                <div className="form-inputs">
                    <div className="form-input-container">
                        <input onChange={(e) => setJobNum(e.target.value)} placeholder="Job Number" type="text" value={jobNum.toUpperCase()} className="form-input"/>
                    </div>
                    <div className="form-input-container">
                        <input onChange={(e) => setPostcode(e.target.value)} placeholder="Postcode" type="text" value={postcode.toUpperCase()} className="form-input"/>
                    </div>
                    <Text fontSize='sm' align='center' mt={-2} mb={5}>This is your billing address postcode</Text>
                    {isError &&
                        <Alert status='error' borderRadius={5}>
                            <AlertIcon/>
                            <Box>
                                <AlertTitle>Login failed.</AlertTitle>
                                <AlertDescription>Check the details you entered are correct.</AlertDescription>
                            </Box>
                        </Alert>
                    }
                </div>
                <Button mt={4} bg='var(--Able-blue)' color='white' size='lg' fontSize='xl' width={175} borderRadius={15}
                    isLoading={isLoading} loadingText='Log In' spinnerPlacement="end" type='submit'>Log In</Button>
            </form>
        </div>
    );
}